import { createApp } from 'vue';
import App from './App.vue';
import store from './store';
//import router from './router';
import  VueGoogleMaps from '@fawmi/vue-google-maps'
//import json global params file if exists
import axios from 'axios';
import Vueform from '@vueform/vueform'
import vueformConfig from './vueform.config'


window.updateCartCountDebounce = null
window.updateCartCount = function () {
    
    if (window.updateCartCountDebounce)
        clearTimeout(window.updateCartCountDebounce);
    
    window.updateCartCountDebounce = setTimeout(() => {
        
        let cart = null;
        let token = null;
        //Fetch cart from API
        if (store.state.token) {
            token = store.state.token
        }
        let params = {
            token: token,
            _wpnonce: window.ajax_var.nonce,
            rand: Math.floor(Math.random() * 1000000)
        }
        // //Add headers type
        axios.defaults.headers.common['Content-Type'] = 'application/json'
        axios.defaults.headers.common['X-WP-Nonce'] = window.ajax_var.nonce

        axios.get('/wp-json/stereostore/v1/cart', { params })
            .then(response => {
                cart = response.data.data
                if (cart && cart.items) {
                    if (document.querySelector('.js-cart-count')) document.querySelector('.js-cart-count').textContent = (cart.items.length > 0) ? cart.items.length : '';
                }
            })
            .catch(error => {
                console.log(error)
            });
        
    }, 500);

}


window.initStereocart = function() {
    const app = createApp(App)
    app.use(store);
    app.use(Vueform, vueformConfig);
    app.use(VueGoogleMaps, {
        load: {
            key: window.ajax_var.gmap_api_key,
            libraries: "places"
        },
    })
    app.config.globalProperties._t = app._component.methods.translateString
    app.mount('#app');

    window.updateCartCount();
}
window.initStereocart();

//New function to add event listener to all add to cart buttons
window.initStereocartButton = function() {
    const addToCartButtons = document.querySelectorAll('.stereostore-add-item');
    addToCartButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
            event.preventDefault();
            const productId = button.dataset.itemId;
            const quantity = button.dataset.itemQuantity;
            const name = button.dataset.itemName;
            const description = button.dataset.itemDescription;
            const price = button.dataset.itemPrice;
            const image = button.dataset.itemImage;
            const url = button.dataset.itemUrl;
            const metadata = button.dataset.itemMetadata?JSON.parse(button.dataset.itemMetadata):{};
            const sku = button.dataset.itemSku?button.dataset.itemSku:button.dataset.itemId;
            const type = button.dataset.itemType;
            
            axios.defaults.headers.common['Content-Type'] = 'application/json'
            axios.defaults.headers.common['X-WP-Nonce'] = window.ajax_var.nonce
            axios.post('/wp-json/stereostore/v1/cart/add', {
                item: {
                    product_id: productId,
                    quantity: quantity,
                    name: name,
                    description: description,
                    price: price,
                    image: image,
                    url: url?url:window.location.href,
                    metadata: metadata,
                    sku: sku,
                    type: type,
                },
                token: store.state.token,
                _wpnonce: window.ajax_var.nonce,
            })
                .then((response) => {
                    store.commit('updateToken', response.data.data.token);
                    location.href = window.ajax_var.pages.cart;
                    try{
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'add_to_cart',
                            'ecommerce': {
                                'currency': window.ajax_var.currency,
                                'items': [{
                                        'id': productId,
                                        'name': name,
                                        'price': price,
                                        'quantity': quantity,
                                        'variant': sku
                                }]
                            }
                        });
                    }catch(e){
                        console.log(e)
                    }
                    window.updateCartCount();
                })
                .catch((error) => {
                    window.updateCartCount();
                    console.log(error);
                });
        });
    }
    );
};

window.StereoStoreAddToCart = async function(product) {
    axios.defaults.headers.common['Content-Type'] = 'application/json'
    axios.defaults.headers.common['X-WP-Nonce'] = window.ajax_var.nonce
    return axios.post('/wp-json/stereostore/v1/cart/add', {
        item: {
            product_id: product.id,
            quantity: product.quantity,
            name: product.name,
            description: product.description,
            price: product.price,
            image: product.image,
            url: product.url?product.url:window.location.href,
            metadata: product.metadata,
            sku: product.sku?product.sku:product.id,
            type: product.type,
        },
        token: store.state.token,
        _wpnonce: window.ajax_var.nonce,
    })
        .then((response) => {
            store.commit('updateToken', response.data.data.token);
            try{
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'add_to_cart',
                    'ecommerce': {
                        'currency': window.ajax_var.currency,
                        'items': [{
                                'id': product.id,
                                'name': product.name,
                                'price': product.price,
                                'quantity': product.quantity,
                                'variant': product.sku
                        }]
                    }
                });
            }catch(e){
                console.log(e)
            }
            window.updateCartCount();
            //Return promise
            return Promise.resolve(response);
        })
        .catch((error) => {
            console.log(error);
            window.updateCartCount();
            return Promise.reject(error);
        });
}
  
  // Appel de la fonction
document.addEventListener('DOMContentLoaded', function() {
    window.initStereocartButton();
});
//Add event listener modularready
window.addEventListener('modularready', () => {
    window.initStereocart();
    
    //router.push(window.location.pathname);
    window.initStereocartButton();
});
